<template>

    <!-- 上传视频 -->

    <div class="m-img-upload" >

        <el-tooltip v-if="video.video_id" :placement="placement" effect="light">
            <div slot="content">
                <video  :src="'' + video.url" autoplay controls muted :style="{'width':width*2.5+'px', 'height':height*2.5+'px'}"></video>
            </div>
            <div class="img-wrapper" :style="{'width':width+'px', 'height':height+'px'}">
                <img :src="'' + video.video_pic" alt="logo" :style="{'width':width+'px', 'height':height+'px'}">
            </div>
        </el-tooltip>

        
      <label v-else  :style="{'width':width+'px', 'height':height+'px',}"  class="input-label" v-loading="loading">
        <i class="el-icon-plus upload-icon"></i>
        <input @change="handleChange($event)" type="file" accept=".mp4" style="display:none">
      </label>

    </div>
      
    

</template>

<script>
import { video, video_del } from '@/untils/axios.js'

export default {
  name:"MVideo",
  props:{
    fileName:{
      type:String,
      default:'',
      required:true,
    },
    width:{
      type:Number,
      default:80
    },
    height:{
      type:Number,
      default:80
    },
    placement: {
      type: String,
      default: 'right',
    },
    video: {
      type: Object,
      default: () => {},
      required: true
    },
    max:{
      type:Number,
      default: 0,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  methods:{
    handleChange(e){
      let files = e.target.files
      console.log(files)
      var image = new FormData()
      image.append('filename', this.fileName)
      image.append('file', files[0])

      this.loading = true
      video(image).then(res => {
        if(res){
          this.video    = res.data
          this.$emit('update:video', this.video)
        }
      }).finally( () => {
        this.loading = false
      })

    },

    handleRemove(id) {
      if(id != "") {
        video_del(id).then( res => {
          if(res) {
            this.video = {}
            this.$emit('update:video', this.video)
          }
        })
      }
    }

  },
}
</script>

<style lang="less" scoped>
.m-img-upload{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
    .img-wrapper {
      display: inline-block;
      position: relative;
      border-radius: 4px;
      margin-right:10px;
      img{ 
          object-fit: cover;
          border-radius: 4px;
      }
    }
  .input-label {
    display: inline-block;
    border: 1px dashed #d9d9d9;
    border-radius: 5px;
    text-align: center;
  }
  .input-label:hover{
    border-color:#409EFF ;
  }
  .upload-icon {
    font-size: 24px;
    color: #8c939d;
    position: relative;
    top: 50%; /*偏移*/
    transform: translateY(-50%);
  }
}
  
</style>